import { getToken } from './auth.js';

const REPORT_PATH = '/api/frontend-error-report';

function reportHeaders() {
  const headers = { 'Content-Type': 'application/json' };
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}

function buildSnippet(data) {
  if (data == null) return '';
  try {
    return typeof data === 'string' ? data : JSON.stringify(data);
  } catch {
    return String(data);
  }
}

/**
 * 上报某次 API 的 HTTP 非 2xx（不经过 axios，避免与拦截器互相触发）
 * @param {object} p
 * @param {string} p.apiMethod
 * @param {string} p.apiUrl
 * @param {number} p.httpStatus
 * @param {string} [p.responseSnippet]
 */
export function reportUserFrontendApiError(p) {
  if (typeof window === 'undefined') return;
  const { apiMethod, apiUrl, httpStatus, responseSnippet = '' } = p;
  if (httpStatus >= 200 && httpStatus < 300) return;
  const path = (apiUrl || '').split('?')[0] || apiUrl;
  if (path === REPORT_PATH || (typeof path === 'string' && path.endsWith(REPORT_PATH))) {
    return;
  }
  const body = {
    page_url: window.location?.href || '',
    api_method: (apiMethod || 'GET').toUpperCase(),
    api_url: apiUrl || '',
    http_status: httpStatus,
    response_snippet: String(responseSnippet).slice(0, 512),
    source: 'user',
  };
  void fetch(REPORT_PATH, {
    method: 'POST',
    headers: reportHeaders(),
    body: JSON.stringify(body),
    credentials: 'same-origin',
  }).catch(() => {});
}

/** 从 axios 错误对象中上报（HTTP 非 2xx 且带 response 时） */
export function reportFromAxiosError(err) {
  const res = err?.response;
  if (!res) return;
  const status = res.status;
  if (status >= 200 && status < 300) return;
  const cfg = err.config || {};
  const base = (cfg.baseURL && String(cfg.baseURL).replace(/\/$/, '')) || '';
  const rel = cfg.url != null ? String(cfg.url) : '';
  const apiUrl = base && rel && !rel.startsWith('http') ? `${base}${rel}` : rel || base;
  const snippet = buildSnippet(res.data);
  reportUserFrontendApiError({
    apiMethod: cfg.method,
    apiUrl: apiUrl || (typeof window !== 'undefined' ? window.location?.origin : '') + rel,
    httpStatus: status,
    responseSnippet: snippet,
  });
}
